import Swiper from 'swiper';

if ($('.js-slider-banner').length) {
  $('.js-slider-banner').each(function (index) {
    const $this = $(this);
    const effect = $this.data('effect') || null;
    const autoplay = $this.data('autoplay') || false;

    $this.addClass(`sban-${index}`);
    $this.find('.swiper-pagination').addClass(`swiper-pagination-${index}`);
    $this.parent().find('.btn-slide--prev').addClass(`prev-${index}`);
    $this.parent().find('.btn-slide--next').addClass(`next-${index}`);

    new Swiper(`.sban-${index}.swiper-container`, {
      slidesPerView: 1,
      spaceBetween: 20,
      autoHeight: false,
      effect: effect,
      fadeEffect: {
        crossFade: true
      },
      autoplay: autoplay,
      loop: true,
      navigation: {
        nextEl: `.next-${index}`,
        prevEl: `.prev-${index}`,
      },
      pagination: {
        el: `.swiper-pagination-${index}`,
        type: 'bullets',
        clickable: true
      },
      breakpoints: {
        1023: {
          autoHeight: true
        }
      },
      on: {
        init: function () {
          let currentTotal = this.slides.length - this.loopedSlides * 2;
          $this.parent().find('.slider-count__total').text(currentTotal);
        },
        slideChange: function () {
          $this.parent().find('.slider-count__current').text(this.realIndex + 1);
        }
      }
    });
  });
}